/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { getUserFirstName } from '@braindate/domain/lib/user/util';
import messages from 'src/shared/app/topic/new/l10n/newTopicNotificationL10n';
import { newTopicRoute } from 'src/shared/app/base/route/setting/routeSettings';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import useSelf from 'src/shared/domain/user/hook/useSelf';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import ContentImg from '!@svgr/webpack?modules!src/shared/app/topic/new/assets/been-awhile.svg';
import NewTopicNotificationModal from './NewTopicNotificationModal';

type Props = {
  notification: Notification<>,
};

const NewTopicNotificationTopicEngagement = ({
  notification,
}: Props): React.Node => {
  const intl = useIntl();
  const navigate = useNavigate();
  const user = useSelf();

  const [newTopicPath] = useRoutes(newTopicRoute);

  const handleAccept = () => {
    navigate(newTopicPath);
  };

  return (
    <NewTopicNotificationModal
      notification={notification}
      title={intl.formatMessage(messages.topicEngagementTitle, {
        firstname: user && getUserFirstName(user),
      })}
      subtitle=""
      content={
        <>
          <p>{intl.formatMessage(messages.topicEngagementContentLine1)}</p>
          <p>
            <i>{intl.formatMessage(messages.topicEngagementContentLine2)}</i>
          </p>
        </>
      }
      image={
        <div>
          {/* $FlowIssue */}
          <ContentImg />
        </div>
      }
      acceptCTA={intl.formatMessage(messages.createTopic)}
      closeCTA={intl.formatMessage(messages.browse)}
      onAccept={handleAccept}
    />
  );
};

export default React.memo<Props>(NewTopicNotificationTopicEngagement);
